module.exports = __webpack_public_path__ + "img/postagram_card.57673411.png";